import React, { useEffect, useState } from "react";

import { cn } from "~/utils";
import { renderBlocker } from "~/utils/subscription";

const FancyLink = ({ children, className, onClick, size = "md", ...props }) => {
  const handleClick = (e) => {
    if (typeof onClick === "function") {
      onClick(e);
    }
  };

  return (
    <a
      className={cn(
        "new-style-button new-style-button-simple group block cursor-pointer",
        className,
        size === "sm" && "!h-8 !text-xs",
        size === "lg" && "!h-10 !text-base",
      )}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  );
};

const RestrictedFancyLink = ({
  className,
  children,
  message,
  onClick,
  ...props
}) => {
  const [locked, setLocked] = useState(false);

  useEffect(() => {
    setLocked(window.DFL?.isUnsubscribedTeacher === true);
  }, []);

  const handleClick = (e) => {
    if (locked) {
      e.preventDefault();
      renderBlocker({ isDismissible: true, message });
      return;
    }
    if (typeof onClick === "function") {
      onClick(e);
    }
  };

  return (
    <FancyLink
      className={cn(locked && "cursor-help", className)}
      onClick={handleClick}
      {...props}
      title={
        locked
          ? message ||
            "Your school needs an active subscription to access this feature"
          : props.title
      }
    >
      {children}
      {locked && (
        <img
          src="/images/lock.svg"
          alt="lock icon"
          style={{ height: "16px", width: "16px" }}
        />
      )}
    </FancyLink>
  );
};

export { FancyLink, RestrictedFancyLink };
